// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.e_peFIsugxlj_DZrXUM7 {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1em;
  background-color: var(--dry-bg);
  color: var(--dry-color);
  font-size: 1rem;
  font-weight: 500;
  border: var(--dry-border);
  border-radius: var(--dry-border-radius);
  padding: 0.5em 0.8em;
  cursor: pointer;
}
.e_peFIsugxlj_DZrXUM7:focus {
  border-color: var(--dry-primary);
}
.e_peFIsugxlj_DZrXUM7 > span {
  flex: 1 1 100%;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.e_peFIsugxlj_DZrXUM7 > svg path {
  fill: var(--dry-border-color);
}
.tYZP_ZrLUaQHJrCj_S2_ {
  position: fixed;
  z-index: var(--dry-popover-zindex);
  background-color: var(--dry-bg);
  list-style: none;
  padding: 2px 0;
  margin: 0;
  border: var(--dry-border);
  border-radius: var(--dry-border-radius);
  box-shadow: var(--dry-shadow);
}
.tYZP_ZrLUaQHJrCj_S2_ > li {
  padding: 0.5em 1em;
  min-height: 1em;
  cursor: pointer;
  transition: all var(--dry-transition);
}
.tYZP_ZrLUaQHJrCj_S2_ > li:hover {
  background-color: var(--dry-hover-bg);
}
.tYZP_ZrLUaQHJrCj_S2_ > li.vUDwk2GpK4z5JUDly4NH,
.tYZP_ZrLUaQHJrCj_S2_ > li:hover.vUDwk2GpK4z5JUDly4NH {
  background-color: var(--dry-primary-highlight);
  color: var(--dry-primary-highlight-text);
  font-weight: bold;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `e_peFIsugxlj_DZrXUM7`,
	"options": `tYZP_ZrLUaQHJrCj_S2_`,
	"active": `vUDwk2GpK4z5JUDly4NH`
};
export default ___CSS_LOADER_EXPORT___;
